import React from 'react';
import { twMerge } from 'tailwind-merge';

const SkeletonElement: React.FC<{ className?: string }> = ({ className }) => (
  <div className={twMerge(`w-full border border-neutral-200 rounded bg-neutral-200`, className)} />
);

const ChatInteractionSkeleton: React.FC = () => {
  return (
    <div className="flex justify-center items-center my-8">
      <div className="flex flex-col w-[16rem] sm:w-[24rem] md:w-[32rem] lg:w-[48rem] gap-4 animate-[scale-skeleton-pulse_2s_ease-in-out_0.5s_infinite]">
        <SkeletonElement className="h-32" />
        <SkeletonElement className="h-64" />
        <SkeletonElement className="h-32" />
        <SkeletonElement className="h-64" />
      </div>
    </div>
  );
};

export default ChatInteractionSkeleton;
